// serviceWorkerRegistration.js

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('Service worker ready (localhost)');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ Service Worker enregistré');
      
      // ✅ AJOUT: Vérifier les mises à jour toutes les heures
      setInterval(() => {
        console.log('🔍 Vérification de mise à jour...');
        registration.update();
      }, 60 * 60 * 1000);

      // ✅ AJOUT: Vérifier immédiatement au chargement
      registration.update();

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        
        console.log('🆕 Nouvelle version détectée');
        
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('🔄 Mise à jour disponible');

              // ✅ MODIFIÉ: Afficher notification et recharger automatiquement
              showUpdateNotification();
              
              // Envoyer SKIP_WAITING au SW
              installingWorker.postMessage({ type: 'SKIP_WAITING' });

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('📦 Contenu mis en cache');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('❌ Erreur Service Worker:', error);
    });
}

// ✅ NOUVELLE FONCTION: Afficher notification et recharger
function showUpdateNotification() {
  const existingNotif = document.getElementById('sw-update-notification');
  if (existingNotif) return; // Ne pas afficher plusieurs fois

  const notification = document.createElement('div');
  notification.id = 'sw-update-notification';
  notification.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 20px;
      text-align: center;
      z-index: 999999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    ">
      <div style="max-width: 600px; margin: 0 auto;">
        <strong style="font-size: 18px; display: block; margin-bottom: 8px;">
          🎉 Nouvelle version disponible !
        </strong>
        <p style="margin: 0; font-size: 14px; opacity: 0.95;">
          Des améliorations et correctifs ont été déployés. La page va se recharger dans <span id="countdown">3</span> secondes...
        </p>
      </div>
    </div>
  `;
  document.body.appendChild(notification);

  // Compte à rebours
  let seconds = 3;
  const countdownEl = document.getElementById('countdown');
  const interval = setInterval(() => {
    seconds--;
    if (countdownEl) countdownEl.textContent = seconds;
    if (seconds <= 0) {
      clearInterval(interval);
      window.location.reload();
    }
  }, 1000);
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('App en mode offline');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('Service Worker désenregistré');
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}